module.exports = __webpack_public_path__ + "static/media/infiniti-bold.4a13f09e.ttf";